module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.200b306f.png";